'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Export = function () {
  function Export(element, args) {
    _classCallCheck(this, Export);

    this.element = element;
    this.args = args;

    this.render(element);
  }

  _createClass(Export, [{
    key: 'render',
    value: function render(element) {
      var fragment = document.createDocumentFragment();

      this.renderNavigation(fragment);

      var div = document.createElement('div');
      div.className = 'viewport';

      var p = document.createElement('p');
      p.innerHTML = 'Er zal een export bestand gemaakt worden van de gegevens die zich op dit moment in uw apparaat bevinden. Let op: uw gegevens worden hierin onversleuteld opgeslagen.';

      div.appendChild(p);

      fragment.appendChild(div);

      var button = document.createElement('button');
      button.innerHTML = 'Maak export bestand';
      button.onclick = this.onexport;

      fragment.appendChild(button);

      element.appendChild(fragment);
    }
  }, {
    key: 'renderNavigation',
    value: function renderNavigation(element) {
      new _NavigationBarControl2.default(element, {
        title: 'Gegevens exporteren',
        leftHandButtons: [{
          onclick: function onclick() {
            history.back();
          },
          icon: '\uE00D'
        }]
      });
    }
  }, {
    key: 'onexport',
    value: function onexport() {
      var data = {};

      Promise.all([window.PRIM.dataAccess.get('people').then(function (people) {
        data.people = people;
      }), window.PRIM.dataAccess.get('organisations').then(function (organisations) {
        data.organisations = organisations;
      }), window.PRIM.dataAccess.get('relationships').then(function (relationships) {
        data.relationships = relationships;
      }), window.PRIM.dataAccess.get('locations').then(function (locations) {
        data.locations = locations;
      }), window.PRIM.dataAccess.get('positions').then(function (positions) {
        data.positions = positions;
      }), window.PRIM.dataAccess.get('educations').then(function (educations) {
        data.educations = educations;
      }), window.PRIM.dataAccess.get('logentries').then(function (logentries) {
        data.logentries = logentries;
      })]).then(function () {
        var blob = new Blob([JSON.stringify(data)], { type: 'text/json' });
        if (navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, 'export.json');
        } else {
          var url = URL.createObjectURL(blob);
          var tempAnchor = document.createElement('a');
          tempAnchor.href = url;
          tempAnchor.download = 'export.json';
          tempAnchor.className = 'invisible';
          document.body.appendChild(tempAnchor);
          tempAnchor.click();
          document.body.removeChild(tempAnchor);
          URL.revokeObjectURL(url);
        }
      }, function () {
        alert('Er is iets fout gegaan tijdens het maken van het export bestand. Probeer het opnieuw.');
      });
    }
  }]);

  return Export;
}();

exports.default = Export;


//////////////////
// WEBPACK FOOTER
// ./js/modules/export/action/Export.js
// module id = 31
// module chunks = 0